export class FileUploader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.render();
        this.init();
    }

    init() {
        this.initEventHandlers();
    }

    render() {
        
        this.innerHTML = `
            <input type="file" class="file-uploader-input" name="file_upload" form="file-upload-form" accept=".pdf" />
            <div class="drag-and-drop-container">
                 <p>Drag & drop files here or click to browse</p>
            </div>
            <div class="current-file">
                <label>Current File:</label>
                <input class="current-file-name" name="" type="text" value="" placeholder="No file allocated"/>
                <a href='/download/uploads/pdf_resources/${this.dataset.pdf_filename}?t=inline' target='_blank' class='preview-link'>
                    Preview
                </a>
            </div>
            <div class='selected-file'>
                <label>Selected File:</label>
                <input class='selected-file-name' name="selected_file_name" type="text" value="" placeholder="No file selected" readonly>
                <div class="file-info">If no file is selected, the current file will continue to be used.</div>
            </div>
            <input type="hidden", name="type" value="4" form="file-upload-form"/>
         `;

        this.container = this.querySelector(".drag-and-drop-container");
        this.input = this.querySelector(".file-uploader-input");

        const currentFileEl = this.querySelector(".current-file-name");
        currentFileEl.value = this.dataset.pdf_filename;


        // need to prepend a dedicated form element for this upload
        const form = document.createElement("form");
        form.setAttribute("id", "file-upload-form");
        form.setAttribute("method", "post");
        form.setAttribute("enctype", "multipart/form-data");
        form.setAttribute("action", "/resources/resources-menu-maintenance");
        const currentFormElem = document.querySelector("form");
        currentFormElem.parentNode.insertBefore(form, currentFormElem);
    }

    initEventHandlers() {
        this.container.addEventListener("click", () => this.input.click());
        this.container.addEventListener("dragover", this.onDragOver.bind(this));
        this.container.addEventListener("dragleave", this.onDragLeave.bind(this));
        this.container.addEventListener("drop", this.onDrop.bind(this));
        this.input.addEventListener("change", this.onFileSelect.bind(this));

        document.addEventListener("post-do-request-event", this.onPostResource.bind(this));
    }

    onDragOver(event) {
        event.preventDefault();
        this.container.classList.add("dragover");
    }

    onDragLeave(event) {
        event.preventDefault();
        this.container.classList.remove("dragover");
    }

    onDrop(event) {
        event.preventDefault();
        this.container.classList.remove("dragover");
        const files = event.dataTransfer.files;
        if (!files.length) {
            return;
        }
        
        // set the uploader input's file to the file dropped
        this.input.files = files;
        const selectedFileEl = this.querySelector(".selected-file-name");
        selectedFileEl.value = files[0].name;
    }

    onFileSelect(event) {
        const files = event.target.files;
        if (!files.length) {
            return;
        }
        this.handleFiles(files);
    }

    handleFiles(files) {
        const selectedFileEl = this.querySelector(".selected-file-name");
        selectedFileEl.value = files[0].name;
    }

    onPostResource(event)
    {
        const selectedFileEl = this.querySelector(".selected-file-name");
        if (selectedFileEl.value == '') {
            return;
        }

        const originalEvent = event.detail.originalEvent;
        const json = event.detail.json;

        if (json.saved) {
            const id = json.id;
             // send the file via fetch
            const fileInput = this.querySelector(".file-uploader-input");
            const formData = new FormData();
            formData.append("id", id);
            formData.append("pdf_file", fileInput.files[0]); 
            formData.append("action", "4");
            fetch("/resources/resources-menu-maintenance", {
                method: "POST",
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.saved) {
                        toastr.success("File uploaded successfully!");

                        const currentFileEl = this.querySelector(".current-file-name");
                        currentFileEl.value = selectedFileEl.value;
                        selectedFileEl.value = "";
                        // update pdf preview link
                        const previewLink = this.querySelector(".preview-link");
                        previewLink.href = `/download/uploads/pdf_resources/${currentFileEl.value}?t=inline`;
                    } else {
                        toastr.error("Error uploading file.")
                    }
                    console.log(data);
                })
                .catch(error => {
                    toastr.error("Error uploading file.");
                    console.error(error);
                });
        }
    }
}



customElements.define('file-uploader', FileUploader);